import React from 'react';
import { IProduct } from '../../../Types/product';
import {
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Radio,
  Typography,
  withStyles,
} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  item: {
    padding: theme.spacing(1.2),
  },
  listItem: {
    border: '2px solid rgba(0, 0, 0, 0.08)',
    boxSizing: 'border-box',
    borderRadius: 12,
    marginTop: 10,
  },
  itemHeader: {
    fontSize: 20,
    lineHeight: '24px',
    direction: 'rtl',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  itemSubheader1: {
    fontSize: 14,
    lineHeight: '20px',
    display: 'block',
  },
  img: { height: 64, width: 64, borderRadius: 8 },
}));

const BlackRadio = withStyles((theme: any) => ({
  root: {
    color: theme.palette.brand.greenDark,
    '&$checked': {
      color: theme.palette.brand.greenDark,
    },
  },
  checked: {},
}))(Radio);

export default function ProductListItem({
  product,
  isSelected,
  onSelect,
}: {
  product: IProduct;
  isSelected: boolean;
  onSelect: (id: string) => void;
}) {
  const classes = useStyles();

  const msrp = product.msrp
    ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(product.msrp)
    : ' ';

  const onSelectCallback = () => onSelect(product.id);

  return (
    <ListItem
      key={product.id}
      button
      className={classes.listItem}
      onClick={onSelectCallback}
    >
      <ListItemIcon>
        <img src={product.image} alt="product" className={classes.img} />
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography paragraph className={classes.itemHeader}>
            {product.asin || product.id}
          </Typography>
        }
        secondary={
          <React.Fragment>
            <Typography
              component="span"
              className={classes.itemSubheader1}
              color="textPrimary"
            >
              {product.name?.length > 25
                ? product.name.slice(0, 20) + '...'
                : product.name}
            </Typography>
            {msrp}
          </React.Fragment>
        }
        className={classes.item}
      />
      <ListItemSecondaryAction>
        <BlackRadio
          checked={isSelected}
          onChange={onSelectCallback}
          name="radio-buttons"
        />
      </ListItemSecondaryAction>
    </ListItem>
  );
}
